import * as React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { IconHelpOutline } from "@origin-digital/ods-icons";
import Logo from "../Logo";
import Toolbar from "../Toolbar";
import MobileToolbar from "../MobileToolbar";
import OverlayNav from "../OverlayNav";
import Navbar from "../Navbar";
import { logout } from "../../../../auth/logout";
import { NavStructurePropTypes, ToolbarItemsPropTypes } from "../../vars";
import { Link } from "../../../Link";
import { HeaderbarBottom } from "./HeaderbarBottom";

const ResponsiveWrapper = styled.div<any>`
  display: ${({ isMobile }: any) => (isMobile ? "block" : "none")};

  ${({ isMobile }: any) => (isMobile ? "position: relative;" : "")};

  @media (min-width: ${(p) => p.theme.breakpoints.lg}) {
    display: ${({ isMobile }: any) => (isMobile ? "none" : "block")};
  }
`;

const ToolbarIcon = styled.div`
  border-left: 1px solid ${(p) => p.theme.colors.grey200};

  a {
    display: inline-block;
    line-height: 64px;
    width: 64px;
    text-align: center;

    svg {
      margin-bottom: 2px;
    }

    &:hover svg {
      color: ${(p) => p.theme.colors.primaryLight};
    }
  }
`;

const PaddedLink = styled(Link)`
  && svg {
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }
`;

const HELP_AND_SUPPORT_PATH = "/help-support";

class Headerbar extends React.Component<any, any> {
  static propTypes = {
    ...NavStructurePropTypes,
    ...ToolbarItemsPropTypes,
    logoutUrl: PropTypes.string,
  };

  static defaultProps = {
    logoutUrl: "/",
  };

  static getDerivedStateFromProps(props, state) {
    if (
      typeof window !== "undefined" &&
      state.toolbarItems.length !== props.toolbarItems.length
    ) {
      const DASHBOARD_PATH = "/my-account/dashboard";
      const isDashboardActive = window.location.pathname.includes(
        DASHBOARD_PATH
      );
      const isHelpAndSupportActive = window.location.pathname.includes(
        HELP_AND_SUPPORT_PATH
      );
      const { toolbarItems } = props;
      const activeToolbarItems = toolbarItems.map((item) => {
        if (
          (item.href === DASHBOARD_PATH && isDashboardActive) ||
          (item.href === HELP_AND_SUPPORT_PATH && isHelpAndSupportActive)
        ) {
          return { ...item, isActive: true };
        }
        return item;
      });

      return {
        menuOpen: state.menuOpen,
        toolbarItems: activeToolbarItems,
      };
    }
    return {
      menuOpen: state.menuOpen,
      toolbarItems: props.toolbarItems,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      toolbarItems: [],
    };
  }

  openMenu = () => ({ menuOpen: true });

  closeMenu = () => ({ menuOpen: false });

  handleMenuToggleClick = () => {
    this.setState(this.openMenu);
  };

  handleCloseMenuClick = () => {
    this.setState(this.closeMenu);
  };

  handleLogoutClick = () => {
    logout();
  };

  render() {
    const { navStructure, className } = this.props;

    return (
      <div
        id="my-account-nav"
        data-id="my-account-nav"
        data-logout-url={this.props.logoutUrl}
        className={className}
        role="navigation"
      >
        <Logo absolute />

        <ResponsiveWrapper isMobile={true}>
          <MobileToolbar onMenuToggleClick={this.handleMenuToggleClick}>
            <ToolbarIcon>
              <PaddedLink href={HELP_AND_SUPPORT_PATH} data-id="help-mobile">
                <IconHelpOutline color="grey300" size="medium" />
              </PaddedLink>
            </ToolbarIcon>
          </MobileToolbar>
          <OverlayNav
            open={this.state.menuOpen}
            onCloseMenuClick={this.handleCloseMenuClick}
            onLogoutClick={this.handleLogoutClick}
            navStructure={navStructure}
          />
        </ResponsiveWrapper>
        <ResponsiveWrapper isMobile={false}>
          <Toolbar items={this.state.toolbarItems} />
          <HeaderbarBottom>
            <Navbar navStructure={navStructure} />
          </HeaderbarBottom>
        </ResponsiveWrapper>
      </div>
    );
  }
}

export default Headerbar;
